import { useQuery } from 'react-query';

import { QueryConfig } from '@shared/api';
import { getPanelLibraryTemplateRevision } from './usePanelLibraryTemplateRevision';
import { getPanelLibraryTemplateRevisions } from './usePanelLibraryTemplateRevisions';

async function getPanelLibraryTemplateCode({
  revisionId: revisionIdParam,
  signal,
  templateId
}: {
  signal?: AbortSignal;
  revisionId?: string;
  templateId: string;
}) {
  const revisions = await getPanelLibraryTemplateRevisions({
    templateId,
    signal
  });
  const revisionId = revisionIdParam ?? revisions[0]?.id;

  if (!revisionId) {
    throw new Error('Panel library template revision not found');
  }

  const revision = await getPanelLibraryTemplateRevision({
    templateId,
    revisionId,
    signal
  });

  return revision.code;
}

export function usePanelLibraryTemplateCode(
  { revisionId, templateId }: { revisionId?: string; templateId?: string },
  config?: QueryConfig<string>
) {
  return useQuery(
    ['panel-library-template-code', { revisionId, templateId }],
    context => {
      if (!templateId) {
        throw new Error('Template ID is required');
      }

      return getPanelLibraryTemplateCode({
        signal: context.signal,
        templateId,
        revisionId
      });
    },
    {
      retry: false,
      ...config,
      enabled: (config?.enabled ?? true) && !!templateId
    }
  );
}
